import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {checkQueryKey, formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {useQueryChancePage} from "@/service/chance.s";
import {ChancePO} from "@/model/customer";
import Box from "@mui/material/Box";
import {ProgressBar} from "@/widget/ProgressBar/ProgressBar";
import {styled, Typography} from "@mui/material";
import Chip from "@mui/material/Chip";
import {Info, Autorenew, Done, ReportProblem} from '@mui/icons-material';
import {WriteChance} from "@/pages/Chance/WriteChance";
import {ViewChance} from "@/pages/Chance/ViewChance";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

const StageChip = styled(Chip)(({theme}) => ({
    backgroundColor: "transparent",
    justifyContent: 'left',
    "& .MuiChip-label": {fontWeight: 500},
    '& .icon': {
        color: 'inherit',
    },
    '&.Open': {
        "& .MuiChip-label": {color: (theme.vars || theme).palette.info.dark},
        color: (theme.vars || theme).palette.info.dark,
        border: `1px solid ${(theme.vars || theme).palette.info.main}`,
    },
    '&.Filled': {
        "& .MuiChip-label": {color: (theme.vars || theme).palette.success.dark},
        border: `1px solid ${(theme.vars || theme).palette.success.main}`,
    },
    '&.PartiallyFilled': {
        "& .MuiChip-label": {color: (theme.vars || theme).palette.warning.dark},
        border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
    },
    '&.Rejected': {
        "& .MuiChip-label": {color: (theme.vars || theme).palette.error.dark},
        border: `1px solid ${(theme.vars || theme).palette.error.main}`,
    },
}));

export const ChanceListPage = () => {
    const {
        mutate: chancePageMutate,
        data: chancePageData,
        isPending: chancePagePending,
    } = useQueryChancePage()

    const columns: GridColDef<ChancePO>[] = [
        // {field: "kind", headerName: "商机名称", flex: 0.6,},
        {field: "category", headerName: "服务名称", flex: 0.6,},
        {
            field: "stageId", headerName: "商机阶段", renderCell: ({value, row}) => {
                let icon: any = null
                let classname = ""

                if (value === 1) {
                    classname = "Rejected"
                    icon = <ReportProblem className="icon"/>
                } else if (value === 2) {
                    classname = "PartiallyFilled"
                    icon = <Info className="icon"/>
                } else if (value === 3) {
                    classname = "Open"
                    icon = <Autorenew className="icon"/>;
                } else if (value === 4) {
                    classname = 'Filled'
                    icon = <Done className="icon"/>;
                }
                return <StageChip className={classname} icon={icon} label={row.stage} variant="outlined"/>
            }
        },
        {
            field: "customerName",
            headerName: "客户名称",
            headerAlign: "left",
            flex: 0.5,
            align: "left",
        },
        {
            field: "creator",
            headerName: "业务人员",
            headerAlign: "center",
            align: "center",
            flex: 0.4,
            display: "flex",
            valueGetter: (_, row) => ({flag: 1, creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "money",
            headerName: "商机金额",
            flex: 0.4,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.money}`}</Box>
        },
        {field: "amount", headerName: "商机数量", width: 80},
        {
            field: "contractId",
            headerName: "是否转化",
            width: 80,
            display: 'flex',
            renderCell: ({row: {contractId}}) => {
                return checkQueryKey(contractId) ? <Typography color={'success'}>已转化</Typography> : <Typography color={'warning'}>未转化</Typography>
            }
        },
        {field: "dealDate", headerName: "预计成交时间", flex: 0.4, valueFormatter: (_, row) => formatTime("D", row.dealDate)},
        {field: "dealRate", headerName: "成交概率", flex: 0.4, headerAlign: 'center', valueGetter: (value, row) => row.dealRate, type: 'number', renderCell: ProgressBar},

    ];

    return (
        <ProTable<ChancePO>
            loading={chancePagePending}
            renderDrawer={{view: <ViewChance mode={'drawer'}/>, write: <WriteChance/>}}
            columns={columns}
            data={chancePageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                }
            }}
            onSearch={(params) => {
                chancePageMutate(params);
            }}
            code={"chance"}
        />
    );
};
